// Angular
import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef, Inject, ViewRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// Material
import { MatPaginator, MatSort, MatDialog, MatTableDataSource, MAT_DIALOG_DATA, MatDialogRef, MatRadioChange } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
// RxJS
import { Observable, BehaviorSubject, Subscription, ReplaySubject } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
// NGRX
// Service
import { SubheaderService } from 'app/core/_base/layout';
import { LayoutUtilsService, MessageType, QueryParamsModel } from 'app/core/_base/crud';
import { KhieuNaiKhachHangService } from '../khieu-nai-khach-hang-service/khieu-nai-khach-hang.service';
//Models
import { KhieuNaiKhachHangModel,KhieuNaiKhachHangCTModel } from '../khieu-nai-khach-hang-model/khieu-nai-khach-hang.model';
import { DatePipe } from '@angular/common';
import { CommonConFig } from 'app/views/pages/nfc/dung-chung/__model/common_config.model';
import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
import { FunctionPublic } from '../../../dung-chung/__function/common_function';
import { DungChungService } from '../../../dung-chung/__services/dung-chung.service'
import moment from 'moment';
import { FileAttachmentModel } from '../../../mua-hang-page/file-attachment/file-attachment-model/file-attachment.model';
@Component({
	selector: 'kt-khieu-nai-khach-hang-detail',
	templateUrl: './khieu-nai-khach-hang-detail.component.html',
	styleUrls: ['../khieu-nai-khach-hang.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [DatePipe]
})
export class KhieuNaiKhachHangDetailComponent implements OnInit, OnDestroy {
	/*Config Form */
	CONFIG: CommonConFig;
	// Public properties
	KhieuNaiKhachHang: KhieuNaiKhachHangModel;
	KhieuNaiKhachHangCT: KhieuNaiKhachHangCTModel;
	KhieuNaiKhachHangForm: FormGroup;
	KhieuNaiKhachHangCTForm: FormGroup;
	hasFormErrors: boolean = false;
	loadingSubject = new BehaviorSubject<boolean>(true);
	loading$: Observable<boolean>;
	viewLoading: boolean = false;
	isChange: boolean = false;
	fixedPoint = 2;
	isZoomSize: boolean = false;
	displayedColumns: string[] = [];
	

	optionsTinhTrang:any[]=[
		{
			value:'KNKH_DANGSOANTHAO',
			name:'Đang soạn thảo'
		},
		{
			value:'KNKH_CHOTIEPNHAN',
			name:'Chờ tiếp nhận'
		},
		{
			value:'KNKH_CHOKIEMTRA',
			name:'Chờ kiểm tra'
		},
		{
			value:'KNKH_CHOCAPNHATHUONGXL',
			name:'Chờ cập nhật hướng xử lý'
		},
		{
			value:'KNKH_HOANTAT',
			name:'Hoàn tất'
		}

	]

	optionsTinhTrangCT:any[]=[
		
		{
			value:'KNKHCT_CHOTIEPNHAN',
			name:'Chờ tiếp nhận'
		},
		{
			value:'KNKHCT_CHOKIEMTRA',
			name:'Chờ kiểm tra'
		},
		{
			value:'KNKHCT_CHOCAPNHATHUONGXL',
			name:'Chờ cập nhật hướng xử lý'
		},
		{
			value:'KNKHCT_HOANTAT',
			name:'Hoàn tất'
		}

	]

	availableColumns = [
		{
			stt: 2,
			name: '#',
			isShow: true
		},
		{
			stt: 2,
			name: 'MaHH',
			isShow: true
		},
		{
			stt: 2,
			name: 'TenHH',
			isShow: true
		},
		{
			stt: 2,
			name: 'SoLotSanPham',
			isShow: true
		},
		{
			stt: 2,
			name: 'SoLuong',
			isShow: true
		},
		{
			stt: 2,
			name: 'SoPhieuGiaoHang',
			isShow: true
		},
		{
			stt: 2,
			name: 'MoTaVanDe',
			isShow: true
		},
		{
			stt: 2,
			name: 'YeuCauKhac',
			isShow: true
		},
		{
			stt: 2,
			name: 'KiemTraHienTruong',
			isShow: true
		},
		{
			stt: 2,
			name: 'BaoCaoKhacPhuc',
			isShow: true
		},
		{
			stt: 2,
			name: 'DinhKemFileKhachHang_Id',
			isShow: true
		},
		{
			stt: 2,
			name: 'DinhKemFileKiemTra_Id',
			isShow: true
		},
		{
			stt: 2,
			name: 'DinhKemFileXuLy_Id',
			isShow: true
		},
		
	];

	previousIndex: number;
	idcocaupb: any;
	userinfor: any = {};
	namenguoitao: string = '';
	ArrayIdNumber: number[] = [];
	private componentSubscriptions: Subscription;


	list_KH: any[] = [];
	select_KH: string[] = [];
	filtered_KH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	KH_FilterCtrl: string = '';
	haveElement_KH: boolean = false;


	list_IdHh: any[] = [];
	select_IdHh: string[] = [];
	filtered_IdHh: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	IdHh_FilterCtrl: string = '';
	haveElement_IdHh: boolean = false;

	getdatenow: Date = new Date();
	path:string='KNKH';
	queryParams:QueryParamsModel;

	loaiHH:any[]=[
		{
			
			name:"Nguyên Liệu",
			value:'1'
		},
		{
			
			name:"Phụ Liệu",
			value:'2'
		},
		{
			
			name:"Hóa Chất",
			value:'3'
		},
		{
			
			name:"Thành Phẩm",
			value:'4'
		},
		{
			
			name:"Bán Thành Phẩm",
			value:'5'
		},
		{
			
			name:"Bao Bì",
			value:'6'
		},
		{
			
			name:"Văn Phòng Phẩm",
			value:'7'
		},
		{
			
			name:"Vật Tư",
			value:'8'
		},
		{
			
			name:"Tài Sản",
			value:'9'
		},
		{
			
			name:"Công Cụ Dụng Cụ",
			value:'10'
		},
		{
			
			name:"Trang Thiết Bị",
			value:'11'
		},
		{
			
			name:"Phụ Gia",
			value:'12'
		},
		{
			
			name:"Nhiên liệu",
			value:'13'
		},
	]


	config = {
		language: 'vi',
		uiColor: '#FF8F35',
		// Define the toolbar: https://ckeditor.com/docs/ckeditor4/latest/features/toolbar.html
		// The standard preset from CDN which we used as a base provides more features than we need.
		// Also by default it comes with a 2-line toolbar. Here we put all buttons in a single row.
		toolbar: [
			{ name: 'document', items: ['Print'] },
			{ name: 'clipboard', items: ['Undo', 'Redo'] },
			{ name: 'styles', items: ['Format', 'Font', 'FontSize'] },
			{ name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'RemoveFormat', 'CopyFormatting'] },
			{ name: 'colors', items: ['TextColor', 'BGColor'] },
			{ name: 'align', items: ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'] },
			{ name: 'links', items: ['Link', 'Unlink'] },
			{ name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote'] },
			{ name: 'insert', items: ['Image', 'Table'] },
			{ name: 'tools', items: ['Maximize', 'Source'] },
			{ name: 'editing', items: ['Scayt'] }
		],
		extraPlugins: 'colordialog,tableresize',
		// Make the editing area bigger than default.
		height: 600,
		disabled: true,
	};
	editorUrl = './plugins/ckeditor/ckeditor.js';
	
	tmpKhieuNaiKhachHangCT:KhieuNaiKhachHangCTModel[]=[];
	disabledcheckbox:boolean=true;

	disabledKiemTraHT:boolean=true;
	disabledYeuCauBC:boolean=true;

	indexDetailCurrent:number=0;
	isShowThemHang:boolean=true;
	constructor(
		public dialogRef: MatDialogRef<KhieuNaiKhachHangDetailComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private KhieuNaiKhachHangFB: FormBuilder,
		private KhieuNaiKhachHangCTFB: FormBuilder,
		public dialog: MatDialog,
		private layoutUtilsService: LayoutUtilsService,
		private changeDetectorRefs: ChangeDetectorRef,
		private changeDetect: ChangeDetectorRef,
		private datePipe: DatePipe,
		private tokenStorage: TokenStorage,
		private khieunaikhachhangsService: KhieuNaiKhachHangService,
		private DungChungService: DungChungService
		) {
		dialogRef.disableClose = true;
	}
	/**
	 * On init
	 */
	ngOnInit() {
		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();
		/*Handel keydown event in dialog*/
		this.dialogRef.keydownEvents().subscribe(event => {
			// 
			if (event.key == this.CONFIG.BUTTON_FORM.BACK.KeyCombine.description) {
				this.back();
			}
			
			this.changeDetect.detectChanges();
		});

		this.Loadcolumntable();
		this.ListIdHh();
		this.ListKhachHang();
		this.tokenStorage.getFullName().subscribe(name => { this.namenguoitao = name })
		this.tokenStorage.getCoCauId().subscribe(cocau => { this.idcocaupb = cocau })
		this.tokenStorage.getUserInfo().subscribe(infor => { this.userinfor = infor });
		this.viewLoading = false;
		this.KhieuNaiKhachHang = new KhieuNaiKhachHangModel();
		
		this.KhieuNaiKhachHang.clear();
		
		if (this.data.KhieuNaiKhachHang && Number(this.data.KhieuNaiKhachHang.Id) > 0) {
			this.khieunaikhachhangsService.getKhieuNaiKhachHangById(this.data.KhieuNaiKhachHang.Id).subscribe(res => {
				if (res.status == 1 && res.data) {
					this.KhieuNaiKhachHang = res.data;
					// console.log("this.KhieuNaiKhachHangde",this.KhieuNaiKhachHang);
					this.createForm();
					this.changeDetectView();
				}
			});
		}
		this.createForm();
		
	}
	/**
	 * On destroy
	 */
	ngOnDestroy() {
		if (this.componentSubscriptions) {
			this.componentSubscriptions.unsubscribe();
		}
	}
	/**
	 * Create form
	 */
	createForm() {
		this.KhieuNaiKhachHangForm = this.KhieuNaiKhachHangFB.group({
			soPhieu: [(this.KhieuNaiKhachHang.SoPhieu == null||this.KhieuNaiKhachHang.SoPhieu=='') ? '' : this.KhieuNaiKhachHang.SoPhieu],
			ngayTao: [(this.KhieuNaiKhachHang.NgayTao == null||this.KhieuNaiKhachHang.NgayTao == '') ? this.FormatDatetime(this.getdatenow) : this.FormatDatetime(this.KhieuNaiKhachHang.NgayTao)],
			nguoiTao: [(this.KhieuNaiKhachHang.NguoiTao == null||this.KhieuNaiKhachHang.NguoiTao=='') ? this.namenguoitao : this.KhieuNaiKhachHang.TenNguoiTao],
			tinhTrang: [(this.KhieuNaiKhachHang.TinhTrang == null||this.KhieuNaiKhachHang.TinhTrang=='') ? this.convertTitleTinhTrang(this.optionsTinhTrang[0].value) : this.convertTitleTinhTrang(this.KhieuNaiKhachHang.TinhTrang)],
			khachHangId: [(this.KhieuNaiKhachHang.KhachHangId == null||this.KhieuNaiKhachHang.KhachHangId==''||this.KhieuNaiKhachHang.KhachHangId=='0') ? '' : this.KhieuNaiKhachHang.KhachHangId+''],
			nguoiTiepNhan: [(this.KhieuNaiKhachHang.NguoiTiepNhan == null||this.KhieuNaiKhachHang.NguoiTiepNhan == '') ? '' : this.KhieuNaiKhachHang.NguoiTiepNhan,Validators.required],
			ngayTiepNhan: [(this.KhieuNaiKhachHang.NgayTiepNhan == null||this.KhieuNaiKhachHang.NgayTiepNhan == '') ? this.getdatenow : this.KhieuNaiKhachHang.NgayTiepNhan,Validators.required],
			TenKH: [(this.KhieuNaiKhachHang.TenKH == null||this.KhieuNaiKhachHang.TenKH == '') ? '' : this.KhieuNaiKhachHang.TenKH],
		});

		this.KhieuNaiKhachHangCTForm = this.KhieuNaiKhachHangCTFB.group({
			
			HangHoaId: [ '',Validators.required ],
			TenHH: [ '',Validators.required ],
			SoLuong: [ '',Validators.required ],
			SoPhieuGiaoHang: [ '',Validators.required ],
			SoLotSanPham: ['',Validators.required ],
			NgaySanXuat: [ this.getdatenow,Validators.required ],
			MoTaVanDe: [ '',Validators.required ],
			KiemTraHienTruong: [],
			KyHanKiemTraHienTruong: [''],
			BaoCaoKhacPhuc: [],
			KyHanBaoCaoKhacPhuc: [''],
			YeuCauKhac: [''],
		});

		this.KhieuNaiKhachHangForm.disable();
		

		var controls=this.KhieuNaiKhachHangCTForm.controls;
		controls['TenHH'].disable();
		controls['KyHanKiemTraHienTruong'].disable();
		controls['KyHanBaoCaoKhacPhuc'].disable();


		if(this.KhieuNaiKhachHang.Id>0){
			this.tmpKhieuNaiKhachHangCT=this.KhieuNaiKhachHang.listKNDetail;
			this.tmpKhieuNaiKhachHangCT=[...this.tmpKhieuNaiKhachHangCT];
		}

		
		
		this.changeDetectView();
	}
	/**
	 * Returns page title
	 */
	getTitle(): string {
		
		return 'Xem chi tiết';
	}
	/**
	 * Check control is invalid
	 * @param controlName: string
	 */
	isControlInvalid(controlName: string): boolean {
		const control = this.KhieuNaiKhachHangForm.controls[controlName];
		const result = control.invalid && control.touched;
		return result;
	}
	/**
	 * Save data
	 *
	 * @param withBack: boolean
	 */
	onSubmit(status: number) {
		this.hasFormErrors = false;
		const controls = this.KhieuNaiKhachHangForm.controls;
		/** check form */
		if (this.KhieuNaiKhachHangForm.invalid) {
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			this.hasFormErrors = true;
			return;
		}

		if(this.tmpKhieuNaiKhachHangCT.length==0){
			const message="Vui lòng thêm khiếu nại khách hàng";
			this.layoutUtilsService.showErorr(message);
			return;
		}
		

		// tslint:disable-next-line:prefer-const
		let editedKhieuNaiKhachHang = this.prepareKhieuNaiKhachHangs(status);
		if (this.KhieuNaiKhachHang.Id > 0) {
			this.updateKhieuNaiKhachHang(editedKhieuNaiKhachHang, status)
			return;
		}
		this.addKhieuNaiKhachHang(editedKhieuNaiKhachHang, status);
	}
	/**
	 * Returns object for saving
	 */
	prepareKhieuNaiKhachHangs(status:number): KhieuNaiKhachHangModel {
		const controls = this.KhieuNaiKhachHangForm.controls;
		const _KhieuNaiKhachHang = new KhieuNaiKhachHangModel();
		_KhieuNaiKhachHang.clear();
		_KhieuNaiKhachHang.SoPhieu = controls['soPhieu'].value;
		_KhieuNaiKhachHang.NgayTao =  moment(this.getdatenow).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
		_KhieuNaiKhachHang.NguoiTao = '0';
		_KhieuNaiKhachHang.TinhTrang = this.convertCodeTinhTrangPhieu(status);
		_KhieuNaiKhachHang.KhachHangId = controls['khachHangId'].value;
		_KhieuNaiKhachHang.NguoiTiepNhan = controls['nguoiTiepNhan'].value;
		_KhieuNaiKhachHang.NgayTiepNhan = moment(controls['ngayTiepNhan'].value).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
		_KhieuNaiKhachHang.listKNDetail=this.tmpKhieuNaiKhachHangCT;
		//gán lại giá trị id 
		if (this.KhieuNaiKhachHang.Id > 0) {
			_KhieuNaiKhachHang.Id = this.KhieuNaiKhachHang.Id;
		}
		return _KhieuNaiKhachHang;
	}
	/**
	 * Add item
	 *
	 * @param _KhieuNaiKhachHang: KhieuNaiKhachHangModel
	 * @param withBack: boolean
	 */
	addKhieuNaiKhachHang(_KhieuNaiKhachHang: KhieuNaiKhachHangModel, status) {
		this.khieunaikhachhangsService.createKhieuNaiKhachHang(_KhieuNaiKhachHang).subscribe(res => {
			if (res.status == 1) {
				this.isChange = true;
				const message = `Khiếu nại khách hàng mới đã được thêm.`;
				this.layoutUtilsService.showInfo(message);
				
				if (this.ArrayIdNumber.findIndex(x => x == res.data.Id) == -1) {
					this.ArrayIdNumber.push(res.data.Id);
				}
				this.KhieuNaiKhachHang = new KhieuNaiKhachHangModel();
				this.KhieuNaiKhachHang.clear();
				if (status == 1) {
					this.back();
				} else if (status == 2) {
					this.KhieuNaiKhachHangForm.reset();
					this.KhieuNaiKhachHang.Id = 0;
					this.createForm();
					this.tmpKhieuNaiKhachHangCT=[];
					this.tmpKhieuNaiKhachHangCT=[...this.tmpKhieuNaiKhachHangCT];
					this.changeDetectView();
				} else {
					this.KhieuNaiKhachHang.Id = res.data.Id;
					this.changeDetectView();
				}
			}
			else {
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});
	}
	/**
	 * Update item
	 *
	 * @param _KhieuNaiKhachHang: KhieuNaiKhachHangsModel
	 * @param withBack: boolean
	 */
	updateKhieuNaiKhachHang(_KhieuNaiKhachHang: KhieuNaiKhachHangModel, status: number) {
		this.khieunaikhachhangsService.updateKhieuNaiKhachHang(_KhieuNaiKhachHang).subscribe(res => {
			if (res.status == 1) {
				this.isChange = true;
				const message = `Khiếu nại khách hàng đã được cập nhật`;
				this.layoutUtilsService.showInfo(message);
				if (this.ArrayIdNumber.findIndex(x => x == res.data.Id) == -1) {
					this.ArrayIdNumber.push(res.data.Id);
				}
				if (status == 1) {
					this.back();
				} else if (status == 2) {
					this.KhieuNaiKhachHang = new KhieuNaiKhachHangModel();
					this.KhieuNaiKhachHang.clear();
					this.KhieuNaiKhachHang.Id = 0;
					this.KhieuNaiKhachHangForm.reset();
					this.createForm();
					this.tmpKhieuNaiKhachHangCT=[];
					this.tmpKhieuNaiKhachHangCT=[...this.tmpKhieuNaiKhachHangCT];
					this.changeDetectView();
				} else {
					this.KhieuNaiKhachHang.Id = res.data.Id;
					this.changeDetectView();
				}
			}
			else {
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});
	}
	/**
	 * Close alert
	 *
	 * @param $event
	 */
	onAlertClose($event) {
		this.hasFormErrors = false;
	}
	numberOnly(event): boolean {
		const charCode = (event.which) ? event.which : event.keyCode;
		if (charCode > 31 && (charCode < 48 || charCode > 57)) {
			return false;
		}
		return true;
	}
	closeDialog() {
		this.dialogRef.close(this.isChange);
	}
	ValidateChangeNumberEvent(event: any) {
		var count = 0;
		for (let i = 0; i < event.target.value.length; i++) {
			if (event.target.value[i] == '.') {
				count += 1;
			}
		}
		var regex = this.CONFIG.REGEX_SPECIAL_CHARACTER;
		// var regex = /[a-zA-Z -!$%^&*()_+|~=`{}[:;<>?@#\]]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			const message = 'Dữ liệu không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Dữ liệu không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
	formatNumber(item: string) {
		if (item == '' || item == null || item == undefined) return '';
		if (typeof (item) === "string") {
			item = item.replace(/,/g, "");
		}
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-' + this.fixedPoint).toFixed(this.fixedPoint)
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0, value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1), (this.fixedPoint + 1));
	}
	f_currency_V2(value: string): any {
		if (value == '-1') return '';
		if (value == null || value == undefined || value == '') value = '0';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}
	changeValueOfForm(controlName: string, event: any) {
		if (this.ValidateChangeNumberEvent(event)) {
			let tmpValue = this.KhieuNaiKhachHangCTForm.controls[controlName].value.replace(/,/g, "");
			this.KhieuNaiKhachHangCTForm.controls[controlName].setValue(
				this.f_currency(this.formatNumber(tmpValue))
			);
		}
		else {
			this.KhieuNaiKhachHangCTForm.controls[controlName].setValue(event.target.value);
		}
	}
	/*begin kéo thả cột */
	findIndexColumn(column: string) {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].name == column)
				return i;
		}
	}
	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}
	dropListDropped(event: CdkDropList, column: string) {
		
		if (event) {
			moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
			this.Loadcolumntable();
		}
	}
	Loadcolumntable() {
		this.displayedColumns = [];
		this.availableColumns.forEach(item => this.displayedColumns.push(item.name));
	}
	/*end kéo thả cột */
	/* formatnumber for calculate */
	FormatCommaNumber(item: string) {
		return item.replace(/,/g, "");
	}
	/*end  formatnumber for calculate*/
	/*format datetime */
	FormatDatetime(datetime) {
		return this.datePipe.transform(datetime, 'dd/MM/yyyy');
	}
	/*end format datetime*/
	f_convertDateTime(date: string) {
		var componentsDateTime = date.split("/");
		var date = componentsDateTime[0];
		var month = componentsDateTime[1];
		var year = componentsDateTime[2];
		var formatConvert = year + "-" + month + "-" + date + "T00:00:00.0000000";
		return new Date(formatConvert);
	}
	f_convertDate(p_Val: any) {
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return a.getFullYear() + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + ("0" + (a.getDate())).slice(-2);
	}
	resizeDialog() {
		if (!this.isZoomSize) {
			this.dialogRef.updateSize('100vw', '100vh');
			this.isZoomSize = true;
		}
		else if (this.isZoomSize) {
			this.dialogRef.updateSize('900px', 'auto');
			this.isZoomSize = false;
		}
	}
	/*Đóng dialog và cập nhập lại tình trạng, trả về highlight ID nếu có*/
	back() {
		
		this.dialogRef.close(
			{
				IsChange: this.isChange,
				ArrayIdNumber: this.ArrayIdNumber
			});
	}
	/* format number currency */
	validationSoLuong(soluong) {
		return soluong.match('^(([1-9][0-9]{0,2},([0-9]{3},)*)[0-9]{3}(\\.[0-9]{1,})?|([1-9]([0-9]+)?)(\\.[0-9]{1,})?|[0](\\.([1-9][0-9]?|[0][1-9])))$')
	}
	//#region Kiểm tra định dạng số lượng 
	keyUpInputKhoiLuong(event) {
		FunctionPublic.preventAlpha(event);
	}
	changeInputKhoiLuong(event, columnName) {
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			event.preventDefault();
		}
		else {
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) { return; }
			let data = FunctionPublic.slListChanged(event);
			if (data) {
				this.KhieuNaiKhachHangForm.controls[columnName].setValue(data);
				this.changeDetect.detectChanges();
			}
		}
	}
	/* end */
	changeDetectView() {
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}

	ListIdHh() {
		let queryParams = new QueryParamsModel({});
		queryParams.filter.listLoaiHH = this.loaiHH.map(x=>x.value);
		this.DungChungService.layDanhSachHHTheoNhieuLoai(queryParams).subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.list_IdHh = res.data;
				this.filtered_IdHh.next(this.list_IdHh.slice());
				this.changeDetectView();
			};
		});
	}
	filterIdHh() {
		
		if (!this.list_IdHh) {
			return;
		}
		// get the search keyword
		let search = this.IdHh_FilterCtrl;
		if (!search) {
			this.filtered_IdHh.next(this.list_IdHh.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filtered_IdHh.next(
			this.list_IdHh.filter(ts =>
				(ts.MaHH+' - '+ts.TenHH).toLowerCase().indexOf(search) > -1)
		);
		this.changeDetect.detectChanges();
	}

	changeHangHoa(){
		if(this.list_IdHh.length>0){
			var controls= this.KhieuNaiKhachHangCTForm.controls;
			var itemHH= this.list_IdHh.filter(x=>x.Id_HH==controls['HangHoaId'].value)
			controls['TenHH'].setValue(itemHH[0].TenHH);
			this.changeDetectView();
		}
	}

	ListKhachHang() {
		
		this.DungChungService.layDanhSachKhachHang().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.list_KH = res.data;
				this.filtered_KH.next(this.list_KH.slice());
				this.changeDetectView();
			};
		});
	}
	filterKhachHang() {
		
		if (!this.list_KH) {
			return;
		}
		// get the search keyword
		let search = this.KH_FilterCtrl;
		if (!search) {
			this.filtered_KH.next(this.list_KH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filtered_KH.next(
			this.list_KH.filter(ts =>
				(ts.Makh+' - '+ts.Tenkh ).toLowerCase().indexOf(search) > -1)
		);
		this.changeDetect.detectChanges();
	}

	changeKhachHang(){
		if(this.list_KH.length>0){
			var controls= this.KhieuNaiKhachHangForm.controls;
			var itemKH= this.list_KH.filter(x=>x.IdKh==controls['khachHangId'].value)
			controls['TenKH'].setValue(itemKH[0].Tenkh);
			this.changeDetectView();
		}
	}

	convertTitleTinhTrang(code: string) {
		switch (code) {
			case this.optionsTinhTrang[0].value:

				return this.optionsTinhTrang[0].name;
			case this.optionsTinhTrang[1].value:

				return this.optionsTinhTrang[1].name;
			case this.optionsTinhTrang[2].value:

				return this.optionsTinhTrang[2].name;
			case this.optionsTinhTrang[3].value:

				return this.optionsTinhTrang[3].name;
				case this.optionsTinhTrang[4].value:

					return this.optionsTinhTrang[4].name;	
			default:
				break;
		}
	}

	generateAutoSoPhieu(){
		this.DungChungService.getBillNumber(this.path).subscribe(res=>{
			if(res&&res.status==1){
				var controls=this.KhieuNaiKhachHangForm.controls;
				controls['soPhieu'].setValue(res.data);
				this.changeDetectView();
			}
		})
	}

	clearSelectIdKH(event: any) {
		this.KhieuNaiKhachHangForm.controls["IdKh"].setValue('');
		event.stopPropagation();
	}

	addDetailKhieuNaiKhachHang(){
		var constrols= this.KhieuNaiKhachHangCTForm.controls;
		var itemHH=this.list_IdHh.filter(x=>x.Id_HH==constrols['HangHoaId'].value);
		
		let item=new KhieuNaiKhachHangCTModel();
		item.clear();
		

		item.HangHoaId=constrols['HangHoaId'].value;
		item.TenHH=itemHH[0].TenHH;
		item.MaHH=itemHH[0].MaHH;
		item.SoLotSanPham=constrols['SoLotSanPham'].value;
		item.SoLuong=constrols['SoLuong'].value;
		item.SoPhieuGiaoHang=constrols['SoPhieuGiaoHang'].value;
		item.NgaySanXuat= moment(constrols['NgaySanXuat'].value).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
		item.MoTaVanDe=constrols['MoTaVanDe'].value;
		item.KiemTraHienTruong=Boolean (JSON.parse(constrols['KiemTraHienTruong'].value));
		item.KyHanKiemTraHienTruong=constrols['KyHanKiemTraHienTruong'].value;
		item.BaoCaoKhacPhuc=Boolean (JSON.parse(constrols['BaoCaoKhacPhuc'].value));
		item.KyHanBaoCaoKhacPhuc=constrols['KyHanBaoCaoKhacPhuc'].value;
		item.YeuCauKhac=constrols['YeuCauKhac'].value;
		item.TinhTrang=this.optionsTinhTrang[0].value;
		this.tmpKhieuNaiKhachHangCT.push(item);
		this.tmpKhieuNaiKhachHangCT=[...this.tmpKhieuNaiKhachHangCT];
		//reset formgroup detail
		this.KhieuNaiKhachHangCTForm.reset();
		this.KhieuNaiKhachHangCTForm.controls['NgaySanXuat'].setValue(moment(this.getdatenow).format('YYYY-MM-DD[T]HH:mm:ss.SSS'));

		this.changeDetectView();
	}
	
	radioKiemTraHienTruongChange($event: MatRadioChange){
		
		var controls=this.KhieuNaiKhachHangCTForm.controls;
		if(controls['KiemTraHienTruong'].value=="1"){
			controls['KyHanKiemTraHienTruong'].enable();
			

		}else{
			controls['KyHanKiemTraHienTruong'].disable();
			
		}
		this.changeDetectView();
	}
	radioYeuCauBaoCaoChange($event: MatRadioChange){
		
		var controls=this.KhieuNaiKhachHangCTForm.controls;
		if(controls['BaoCaoKhacPhuc'].value=="1"){
			
			controls['KyHanBaoCaoKhacPhuc'].enable();

		}else{
			
			controls['KyHanBaoCaoKhacPhuc'].disable();
		}
		this.changeDetectView();
	}

	convertCodeTinhTrangPhieu(status:number){
		switch (status) {
			case 0:
				
				return this.optionsTinhTrang[0].value;
			case 1:
				
				return this.optionsTinhTrang[1].value;
			case 2:
				
				return this.optionsTinhTrang[1].value;
		
			default:
				break;
		}
	}

	removeDetailKhieuNaiKhachHang(item:KhieuNaiKhachHangCTModel){
		let index = this.tmpKhieuNaiKhachHangCT.indexOf(item);
		this.tmpKhieuNaiKhachHangCT.splice(index,1);
		this.tmpKhieuNaiKhachHangCT=[...this.tmpKhieuNaiKhachHangCT];
		this.changeDetectView();
	}

	cloneDetailKhieuNaiKhachHang(item:KhieuNaiKhachHangCTModel){
		
		let controls=this.KhieuNaiKhachHangCTForm.controls;
		controls['HangHoaId'].setValue(item.HangHoaId);
		controls['TenHH'].setValue(item.TenHH);
		controls['SoLuong'].setValue(this.f_currency(this.formatNumber(item.SoLuong)));
		controls['SoPhieuGiaoHang'].setValue(item.SoPhieuGiaoHang);
		controls['SoLotSanPham'].setValue(item.SoLotSanPham);
		controls['NgaySanXuat'].setValue(item.NgaySanXuat);
		controls['MoTaVanDe'].setValue(item.MoTaVanDe);
		controls['KiemTraHienTruong'].setValue(Number(item.KiemTraHienTruong).toString());
		controls['KyHanKiemTraHienTruong'].setValue(item.KyHanKiemTraHienTruong);
		controls['BaoCaoKhacPhuc'].setValue(Number(item.BaoCaoKhacPhuc).toString());
		controls['KyHanBaoCaoKhacPhuc'].setValue(item.KyHanBaoCaoKhacPhuc);
		controls['YeuCauKhac'].setValue(item.YeuCauKhac);
		this.indexDetailCurrent=this.tmpKhieuNaiKhachHangCT.indexOf(item);
		this.isShowThemHang=false;
		this.changeDetectView();
	}

	updateDetailKhieuNaiKhachHang(){
		let controls=this.KhieuNaiKhachHangCTForm.controls;
		this.tmpKhieuNaiKhachHangCT[this.indexDetailCurrent].HangHoaId=controls['HangHoaId'].value;
		this.tmpKhieuNaiKhachHangCT[this.indexDetailCurrent].TenHH=controls['TenHH'].value;
		this.tmpKhieuNaiKhachHangCT[this.indexDetailCurrent].SoLuong=this.f_currency(this.formatNumber(controls['SoLuong'].value+''));
		this.tmpKhieuNaiKhachHangCT[this.indexDetailCurrent].SoPhieuGiaoHang=controls['SoPhieuGiaoHang'].value;
		this.tmpKhieuNaiKhachHangCT[this.indexDetailCurrent].SoLotSanPham=controls['SoLotSanPham'].value;
		this.tmpKhieuNaiKhachHangCT[this.indexDetailCurrent].NgaySanXuat=moment(controls['NgaySanXuat'].value).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
		this.tmpKhieuNaiKhachHangCT[this.indexDetailCurrent].MoTaVanDe=controls['MoTaVanDe'].value;
		this.tmpKhieuNaiKhachHangCT[this.indexDetailCurrent].KiemTraHienTruong=Boolean (JSON.parse(controls['KiemTraHienTruong'].value));
		this.tmpKhieuNaiKhachHangCT[this.indexDetailCurrent].KyHanKiemTraHienTruong=controls['KyHanKiemTraHienTruong'].value;
		this.tmpKhieuNaiKhachHangCT[this.indexDetailCurrent].BaoCaoKhacPhuc=Boolean (JSON.parse(controls['BaoCaoKhacPhuc'].value));
		this.tmpKhieuNaiKhachHangCT[this.indexDetailCurrent].KyHanBaoCaoKhacPhuc=controls['KyHanBaoCaoKhacPhuc'].value;
		this.tmpKhieuNaiKhachHangCT[this.indexDetailCurrent].YeuCauKhac=controls['YeuCauKhac'].value;
		this.tmpKhieuNaiKhachHangCT=[...this.tmpKhieuNaiKhachHangCT];
		this.changeDetectView();

	}

	clearSelectKhachHang(event: any) {
		this.KhieuNaiKhachHangForm.controls["khachHangId"].setValue('');
		event.stopPropagation();
	}

	changeMoTaVanDe(){
		var controls=this.KhieuNaiKhachHangCTForm.controls;
	}

	getNameKH(){
		let name = '';
		
		if(this.list_KH.length > 0){
			var item = this.list_KH.filter(x => x.IdKh == +this.KhieuNaiKhachHangForm.controls['khachHangId'].value);
			if(item.length > 0) name = item[0].Makh;
		}
		return name ? name : '';
	}

	downLoadFile(File: FileAttachmentModel) {
		
		if (File.Id > 0) {
			this.khieunaikhachhangsService.Xuatfile(File);
		} else {

			var a = document.createElement("a");
			a.href = `data:application/${File.extension};base64, ${File.base64}`;
			a.download = File.filename + "." + File.extension;
			a.click();
		}

	}

	f_number(item: any = "0.00") {
		return FunctionPublic.F_NUMBER(item);
	}
}
